import { render, staticRenderFns } from "./NoticeList.vue?vue&type=template&id=a5ef3d78&scoped=true"
import script from "./NoticeList.vue?vue&type=script&lang=js"
export * from "./NoticeList.vue?vue&type=script&lang=js"
import style0 from "./NoticeList.vue?vue&type=style&index=0&id=a5ef3d78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ef3d78",
  null
  
)

export default component.exports